const ListHub = () => import('@/views/hub/List_Hub');
const EditHub = () => import('@/views/hub/Edit_Hub');
const DetailHub = () => import('@/views/hub/Detail_Hub');

export default [
  {
    path: 'Hubs',
    redirect: '/hubs/list',
    name: 'Hubs',
    component: {
      render(c) { return c('router-view'); },
    },
    children: [
      {
        path: 'list',
        name: 'Hub List',
        component: ListHub,
      },
      {
        path: 'edit',
        name: 'Hub New',
        component: EditHub,
      },
      {
        path: 'edit/:hashID',
        name: 'Hub Edit',
        component: EditHub,
      },
      {
        path: 'detail/:hashID',
        name: 'Hub Detail',
        component: DetailHub,
      },
    ],
  },
];
